var map = {
	"./logoText_atlas.png": 49618,
	"./logoText_co3.png": 70622,
	"./logoText_corpsconnect.png": 71712,
	"./logoText_kasconnect.png": 39440,
	"./logoText_kiwanis.png": 96177,
	"./logoText_korponnect.png": 88922,
	"./logoText_landfrauen.png": 23207,
	"./logoText_metallverband.png": 36460,
	"./logoText_soroptimist.png": 60992,
	"./logoText_yoga.png": 41655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28658;